import { Cancel } from "@mui/icons-material";
import React from "react";
import { Modal, ModalBody } from "reactstrap";
import defaultImage from "../assets/img/defaultIcon.png";

const DriverDetailModal = ({ isOpen, toggle, driver, darkMode, color }) => {
  if (!driver) return null;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      contentClassName={darkMode ? "bg-dark text-light" : "bg-white text-dark"}
      style={{
        borderRadius: "18px",
        overflow: "hidden",
      }}
    >
      <ModalBody
        className="p-4 position-relative"
        style={{
          borderRadius: "18px",
          minWidth: "320px",
          boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
        }}
      >
        <button
          onClick={toggle}
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            background: "transparent",
            border: "none",
            color: darkMode ? "#fff" : "#000",
            cursor: "pointer",
            fontSize: "20px",
            zIndex: 10,
          }}
          aria-label="Close"
        >
          <Cancel size={20} />
        </button>

        <div className="text-center mb-4">
          <img
            src={driver?.profileImage || defaultImage}
            alt="Driver"
            style={{
              width: "130px",
              height: "130px",
              borderRadius: "50%",
              objectFit: "cover",
              border: `4px solid ${color}`,
              boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
            }}
          />
        </div>

        <div className="text-center">
          <p
            style={{
              fontSize: "14px",
              fontWeight: 500,
              color: darkMode ? "#ccc" : "#888",
              marginBottom: "4px",
            }}
          >
            {driver?.type?.toUpperCase() || "DRIVER"}
          </p>

          <h4
            style={{
              fontWeight: 700,
              fontSize: "20px",
              color: darkMode ? "#fff" : "#222",
              marginBottom: "12px",
            }}
          >
            {driver?.name || "No Name"}
          </h4>

          {driver?.contactNumber && (
            <p
              style={{
                fontSize: "15px",
                color: darkMode ? "#bbb" : "#555",
                marginBottom: "6px",
              }}
            >
              📞 {driver.contactNumber}
            </p>
          )}

          {driver?.email && (
            <p
              style={{
                fontSize: "15px",
                color: darkMode ? "#bbb" : "#555",
                marginBottom: "6px",
              }}
            >
              📧 {driver.email}
            </p>
          )}
        </div>

        <div
          style={{
            marginTop: "20px",
            height: "3px",
            width: "60px",
            backgroundColor: color,
            borderRadius: "2px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        />
      </ModalBody>
    </Modal>
  );
};

export default DriverDetailModal;
